import { URL_BASE } from "@/helper/constants.js";

export default {
    imageBaseURL: URL_BASE,
    imageS3BaseURL: "https://newimages.brijimages.com/",

    movieImages: {
        moviesUploadThumbnailImage: "280*350",
    },
    dateFormat: "dd MMM yyyy",
    cookiekeys: {
        BRHSID: 'BRHSID'
    }
}



// WEBPACK FOOTER //
// ./src/helper/constant.js